const VIOLATION_LIST = [
    '',
    'Nghỉ dưới 15 phút',
    'Học quá 4 tiếng',
    'Truyền dữ liệu quá 2 phút',
    'Học quá 10 tiếng trong 24h',
    'Tốc độ không phù hợp',
    'Hình phiên giữa không trung thực',
    'Sai học viên',
    'Hình đăng nhập/đăng xuất không hợp lệ',
    'Phiên học không xác thực',
    'Lộ trình ngoài tỉnh',
    // Chạy sai tuyến đã đăng ký — khác 'Lộ trình ngoài tỉnh' (ra khỏi tỉnh).
    // Phải khớp CANONICAL_VIOLATIONS bên uniapp-backend/src/utils/dat-violation-map.util.js.
    'Tập lái sai lộ trình',
    'Phiên học không xác thực giáo viên',
    'Phiên học trước ngày xuống DAT',
    'Phiên học dưới 5 phút',
    'Tỷ lệ nhận diện dưới 75%',
    'Xe hết hạn GPTL',
    'Lỗi kỹ thuật chưa sửa',
    'Sai quy trình',
    'Phiên học không hợp lệ',
    'Phiên học trùng lặp giáo viên',
]

// Từ khóa regex (case-insensitive, BE escape sẵn) dùng khi LỌC theo lỗi.
// DB còn lẫn biến thể cũ do audit V1/n8n ghi ('Tỷ lệ nhận diện < 75%',
// 'Dưới 5 phút') bên cạnh chuỗi chuẩn mới — lọc theo cụm chung để match
// cả hai. 'Phiên học trùng lặp giáo viên' lưu dạng 'Trùng với <id>'.
const VIOLATION_FILTER_TERMS = {
    'Phiên học trùng lặp giáo viên': 'Trùng',
    'Tỷ lệ nhận diện dưới 75%': 'nhận diện',
    'Phiên học dưới 5 phút': 'dưới 5 phút',
}

export {
    VIOLATION_LIST,
    VIOLATION_FILTER_TERMS,
}
